var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80892 2.18788L0.286337 8.71046L0.00478704 11.3852C-0.042138 11.7371 0.262875 12.0421 0.614813 11.9952L3.28954 11.7137L9.81212 5.19108L6.80892 2.18788ZM11.6657 1.74209L10.2579 0.334341C9.83558 -0.111447 9.10824 -0.111447 8.66246 0.334341L7.34856 1.64824L10.3518 4.65144L11.6657 3.33754C12.1114 2.89176 12.1114 2.16442 11.6657 1.74209Z",
    fill: "#CCCCCC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.635690c1aeb982b65bb6bdda4c0bea5b.svg";
export { ForwardRef as ReactComponent };